<template>
  <div class="main">
    <el-container>
      <el-header>健康水平实验评估系统</el-header>
      <el-main>
        <el-row>
          <el-col
            :xs="{ span: 24, offset: 0 }"
            :sm="{ span: 24, offset: 0 }"
            :md="{ span: 16, offset: 4 }"
            :lg="{ span: 12, offset: 6 }"
            :xl="{ span: 12, offset: 6 }"
          >
            <div class="box" id="report">
              <div class="info">
                <div>
                  <div>姓名</div>
                  <hr />
                  <div>{{ basic.name }}</div>
                </div>
                <div>
                  <div>性别</div>
                  <hr />
                  <div>{{ basic.category }}</div>
                </div>
                <div>
                  <div>年龄</div>
                  <hr />
                  <div>{{ basic.age }}</div>
                </div>
                <div>
                  <div>检查日期</div>
                  <hr />
                  <div>{{ basic.date1 }}</div>
                </div>
              </div>
              <el-table :data="tableData" border>
                <el-table-column prop="item" label="项目"> </el-table-column>
                <el-table-column prop="vule" label="分值"> </el-table-column>
              </el-table>
              <div class="block">
                <img style="width: 100%" src="../assets/description.jpg" />
                <el-row data-html2canvas-ignore>
                  <el-button
                    type="primary"
                    @click="$router.push('/description')"
                    >系统说明</el-button
                  >
                  <el-button type="primary" @click="savepic"
                    >截屏保存</el-button
                  >
                  <el-button
                    type="primary"
                    @click="$router.push('/form?mode=mod')"
                    >返回</el-button
                  >
                  <el-button type="primary" @click="$router.replace('/')"
                    >退出</el-button
                  >
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
      <!-- <el-footer>版本 V3.0</el-footer> -->
    </el-container>
    <el-dialog width="95%" :visible.sync="dialogVisible">
      <div class="r-title">长按图片保存到相册</div>
      <img :src="reportImg" alt="" srcset="" class="r-img" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "Report",
  data() {
    let result = analyse(this.$store.state.form);
    return {
      fits: ["contain"],
      src: "../assets/description.jpg",
      dialogVisible: false,
      reportImg: "",
      basic: {},
      tableData: [
        {
          item: "健康-疾病综合分",
          vule: result.HI.toFixed(3),
        },
        {
          item: "分子脆弱指数",
          vule: result.MF.toFixed(3),
        },
        {
          item: "脏器脆弱指数",
          vule:
            result.OF.toFixed(3) +
            (this.$store.state.form.opt.BSonar == -1 &&
            this.$route.query.mode != "demo"
              ? "(非影像学资料，仅供参考)"
              : ""),
        },
        {
          item: "运动肥胖指数",
          vule: result.EOI.toFixed(3),
        },
        {
          item: "健康状态",
          vule: result.status,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.basic = this.$store.state.form.basic;
  },
  methods: {
    savepic() {
      document.getElementsByClassName("el-main")[0].scrollTop = 0;
      html2canvas(document.getElementById("report")).then((canvas) => {
        let pic = canvas.toDataURL("image/png");
        if (isMobile()) {
          this.reportImg = pic;
          this.dialogVisible = true;
        } else {
          let a = document.createElement("a");
          a.download = "报告";
          a.href = pic;
          a.click();
        }
      });
    },
  },
};

function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

function analyse(form) {
  let MF, OF, EOI, BA, HI, status;
  let BMI =
    parseFloat(form.basic.weight) /
    Math.pow(parseFloat(form.basic.height) / 100, 2);
  {
    let M = over(form.test.glucose, 6.1);
    M += abnor(form.test.liverf);
    M += abnor(form.test.enzyme);
    M += abnor(form.test.kidneyf);
    M += abnor(form.test.fat);

    M += abnor(form.opt.cell);
    M += abnor(form.opt.piss);
    M += abnor(form.opt.cprotn);

    let F =
      5 + exist(form.opt.cell) + exist(form.opt.piss) + exist(form.opt.cprotn);

    MF = (M * 100) / F;
  }
  if (form.opt.BSonar != "-1") {
    let O = over(form.basic.pressed, 140);
    O += over(form.basic.relaxed, 90);
    O += abnor(form.opt.chest);
    O += abnor(form.opt.hearth);
    O += Object.values(form.bsonar).filter((v) => v == "1").length;

    let F = 4 + Object.values(form.bsonar).length - 3;

    OF = (O * 100) / F;
  } else {
    OF = Math.max(
      BMI * 0.541 -
        (form.basic.category == "男" ? 1 : 0) * 3.82 +
        parseFloat(form.basic.relaxed) * 0.203 +
        parseFloat(form.basic.pressed) * 0.251 +
        parseFloat(form.basic.age) * 0.563 -
        63.389,
      0
    );
  }

  EOI =
    ((3.876 * parseFloat(form.basic.waist)) /
      (0.54 * parseFloat(form.basic.weight) + 41.7) -
      3.58) *
    100;
  BA =
    (1.14 -
      0.03 * parseFloat(form.test.protn) +
      0.016 * parseFloat(form.basic.age)) *
    100;

  if (form.opt.BSonar != "-1") {
    let av = (MF + OF + EOI + BA) / 4;
    if (form.basic.category == "男") {
      HI = 16 + 0.843 * av;
    } else {
      HI = 19.5 + 0.774 * av;
    }
  } else {
    let av = (MF + EOI + BA) / 3;
    if (form.basic.category == "男") {
      HI = 14.9 + 0.777 * av;
    } else {
      HI = 18.9 + 0.714 * av;
    }
  }
  status = "";
  if (
    parseFloat(form.basic.pressed) >= 140 ||
    parseFloat(form.basic.relaxed) >= 90
  ) {
    status = "高血压";
  }
  if (parseFloat(form.test.glucose) > 7) {
    status += ";糖尿病";
  }
  if (status[0] == ";") {
    status.substring(1);
  }
  if (status == "") {
    if (BMI < 18.5) {
      status = "偏瘦";
    } else {
      let baseline;
      if (parseFloat(form.basic.age) <= 50) {
        baseline = 50;
      } else {
        baseline = parseFloat(form.basic.age) + 5;
      }
      if (HI <= baseline) {
        status = "良好";
      } else {
        status = "欠佳";
      }
    }
  }
  return {
    MF,
    OF,
    EOI,
    BA,
    HI,
    status,
  };
}

function over(item, limit) {
  return parseFloat(item) >= limit ? 1 : 0;
}

function abnor(item) {
  return Math.max(parseFloat(item), 0);
}

function exist(item) {
  return item > -1 ? 1 : 0;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: $green;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.el-table {
  width: 98%;
  margin: 15px auto;
}
table {
  width: 100%;
}
hr {
  border: 1px solid #fff;
}
.box {
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
  padding-bottom: 15px;
}

.r-img {
  width: 90%;
}

.r-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
